// Room Visualizer data. Each product entry maps to room-specific renders
// pre-generated to /public/visualizer/.
//
// Compatibility model:
//   • Each room declares `allowedDisciplines` — the visualizer only shows
//     products that fit that room. Wet areas exclude timber & carpet.
//   • Bathroom is a special "dual-material" room: the user picks a floor
//     AND a wall material (both must be tile or stone). The render is
//     pre-generated per (floor, wall) combination.
//   • Single-material rooms use: /visualizer/<productId>-<roomKey>.jpg
//   • Bathroom uses:              /visualizer/bathroom-<floorId>-wall-<wallId>.jpg
import { PRODUCTS } from "@/data/products";

export const VIZ_ROOMS = [
  { key: "living",   label: "Living Room", allowedDisciplines: ["Timber", "Carpet", "Tile", "Stone"] },
  { key: "kitchen",  label: "Kitchen",     allowedDisciplines: ["Timber", "Tile", "Stone"] },
  { key: "bedroom",  label: "Bedroom",     allowedDisciplines: ["Timber", "Carpet", "Stone"] },
  { key: "hallway",  label: "Hallway",     allowedDisciplines: ["Timber", "Carpet", "Tile", "Stone"] },
  { key: "foyer",    label: "Foyer",       allowedDisciplines: ["Timber", "Tile", "Stone"] },
  { key: "bathroom", label: "Bathroom",    allowedDisciplines: ["Tile", "Stone"], dualMaterial: true },
];

// Bathroom-eligible products — every Tile and Stone product from the full
// Collection is a valid floor or wall choice, so the picker mirrors what a
// designer would actually spec.
export const BATHROOM_PRODUCTS = PRODUCTS
  .filter((p) => p.discipline === "Tile" || p.discipline === "Stone")
  .map((p) => ({ id: p.id, name: p.name, discipline: p.discipline, subtitle: p.finish }));

export const roomImage = (productId, roomKey) =>
  `/visualizer/${productId}-${roomKey}.jpg`;

export const bathroomImage = (floorId, wallId) =>
  `/visualizer/bathroom-${floorId}-wall-${wallId}.jpg`;

// Pre-rendered bathroom colour combination (floor colour index + wall colour
// index). Tried before any runtime render, so a pre-generated combination is
// instant. `gen_bathroom_colours.py` writes these files.
export const bathroomColourImage = (floorId, fIdx, wallId, wIdx) =>
  `/visualizer/bathroom-${floorId}-c${fIdx}-wall-${wallId}-c${wIdx}.jpg`;

// Popular Polytec-inspired joinery finishes shown when the Kitchen room is
// active. joineryIdx 0 = the base render (no override); joineryIdx > 0 uses
// the pre-generated /visualizer/<productId>-kitchen-<id>.jpg file.
export const KITCHEN_JOINERY = [
  { id: null,             name: "Studio Default", hex: "#8C7355" },
  { id: "boston-oak",     name: "Boston Oak",     hex: "#C29A6B" },
  { id: "notaio-walnut",  name: "Notaio Walnut",  hex: "#5A3F2E" },
  { id: "prime-oak",      name: "Prime Oak",      hex: "#D6B384" },
  { id: "coastal-oak",    name: "Coastal Oak",    hex: "#E4D5BF" },
  { id: "classic-white",  name: "Classic White",  hex: "#F0EDE6" },
  { id: "bianco-elm",     name: "Bianco Elm",     hex: "#C7B79B" },
  { id: "artisan-oak",    name: "Artisan Oak",    hex: "#5A4739" },
];
